// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"b184a538","549":"bf95b181","781":"1622a176","984":"e282f777"}[chunkId] + ".chunk.js";
};